import '../../httpservices/core/ajax.httpservice.core';

class SettingsHttpService {

    ChangeEmailInitData() {
        return $.get('Patient/Settings/ChangeEmailInitData');
    }

    ChangePasswordInitData() {
        return $.get('Patient/Settings/ChangePasswordInitData');
    }

    ChangeEmail(email1, email2) {
        return $.post('Patient/Settings/ChangeEmail', { email1, email2 });
    }

    ChangePassword(oldPassword, newPassword1, newPassword2) {
        return $.post('Patient/Settings/ChangePassword', { oldPassword, newPassword1, newPassword2 });
    }

    ChangeEmailSuccess() {
        return $.get('Patient/Settings/LogOut');
    }

    VerifyEmail(activationCode) {
        return $.post('Account/VerifyEmailSubmit', activationCode);
    }

    Transition(mrn) {
        return $.post('Account/TransitionSubmit', { mrn: mrn });
    }

    EmailMisMatchUpdateEmail(whichEmailAddress, customEmailAddress) {
        return $.post('Account/EmailMisMatchSubmit', { whichEmailAddress: whichEmailAddress, customEmailAddress: customEmailAddress });
    }

    //not sure if this is the right location, but keep it here for now
    ResetPassword(oldPassword, newPassword1, newPassword2) {
        return $.post('Account/ResetPasswordSubmit', { oldPassword, newPassword1, newPassword2 });
    }

    ForgotUserName(email) {
        return $.post('Forgot/UserNameSubmit', { emailAddress: email });
    }

    ForgotPassword(userId, dob, email) {
        return $.post('Forgot/PasswordSubmit', { userId: userId, dateOfBirth: dob, emailAddress: email });
    }
    //not sure if this is the right location, but keep it here for now

    GetNotificationPreferences() {
        return $.get('Patient/Settings/GetNotificationPreferences');
    }

    ////itemsToSave = [] of BaseNotificationItem.cs
    ChangeNotificationPreferences(itemsToSave, textMessageOptInToSave, apptTexting, telemedTexting) {
        return $.post('Patient/Settings/ChangeNotifications', { notificationsToSave: itemsToSave, optInStatusToSave: textMessageOptInToSave, apptTexting, telemedTexting });
    }

    ChangeNotificationsSuccess() {
        return $.get('Patient/Settings/BackToLandingPage');
    }

    UpdateLanguagePreference(selectedLanguage) {
        return $.post('Patient/Settings/UpdateLanguagePreference', selectedLanguage);
    }

    EmailVerificationForInvite(email1, email2) {
        return $.post('Patient/Settings/EmailVerificationForInvite', { email1: email1, email2: email2 });
    }

}

export const SettingsHttpSvc = new SettingsHttpService();